module.exports = __webpack_public_path__ + "img/list.897f4442.png";